var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C7C7C",
    d: "M2.5 5C3.875 5 5 3.875 5 2.5S3.875 0 2.5 0 0 1.125 0 2.5 1.125 5 2.5 5zm0 2.5C1.125 7.5 0 8.625 0 10s1.125 2.5 2.5 2.5S5 11.375 5 10 3.875 7.5 2.5 7.5zm0 7.5C1.125 15 0 16.125 0 17.5S1.125 20 2.5 20 5 18.875 5 17.5 3.875 15 2.5 15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ddce3570.svg";
export { ForwardRef as ReactComponent };